import { render } from "./doi.vue?vue&type=template&id=758b7d93&scoped=true"
import script from "./doi.vue?vue&type=script&lang=js"
export * from "./doi.vue?vue&type=script&lang=js"

import "./doi.vue?vue&type=style&index=0&id=758b7d93&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758b7d93"]])

export default __exports__